export default {
  dark: () => import("/home/runner/work/pictureclub/pictureclub/layouts/dark.vue").then(m => m.default || m),
  default: () => import("/home/runner/work/pictureclub/pictureclub/layouts/default.vue").then(m => m.default || m),
  dev: () => import("/home/runner/work/pictureclub/pictureclub/layouts/dev.vue").then(m => m.default || m),
  "local-storage-splash": () => import("/home/runner/work/pictureclub/pictureclub/layouts/local-storage-splash.vue").then(m => m.default || m),
  "persistent-splash": () => import("/home/runner/work/pictureclub/pictureclub/layouts/persistent-splash.vue").then(m => m.default || m)
}